import { render, staticRenderFns } from "./AskBox.vue?vue&type=template&id=aeb9165c&scoped=true&"
import script from "./AskBox.vue?vue&type=script&lang=js&"
export * from "./AskBox.vue?vue&type=script&lang=js&"
import style0 from "./AskBox.vue?vue&type=style&index=0&id=aeb9165c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb9165c",
  null
  
)

export default component.exports